module.exports = __webpack_public_path__ + "img/location-icn.c0e084dd.png";